import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const GetJob = CreateProcess({
	method: "GET",
	name: "GetJob",
	type: "JOBS:FETCHONE",

	request: (props) => ({
		url: `/api/user_jobs/${props.jobID}/`,
	}),

	success: (response) => fromJS(response.data),
});
